import Box from '@/components/common/Box'
import { radius, sizing, spacing } from '@/styles/designTokens'
import { ItemSlot } from '@/pages/menu/MenuPage.styled'
import {
	SkeletonBlock,
	SkeletonBlockLight,
	SkeletonCard,
	SkeletonTextBody,
	SkeletonInfoGroup,
	SkeletonPriceRow,
	SkeletonImagePlaceholder,
	SkeletonAddButton,
	SkeletonCategoryRow,
	SkeletonItemGrid,
} from './MenuSkeleton.styled'

function SkeletonItem({ titleWidth }: { titleWidth: string }) {
	return (
		<SkeletonCard>
			<SkeletonTextBody>
				<SkeletonInfoGroup>
					<SkeletonBlock
						sx={{
							height: sizing.skeletonTextHeightMd,
							width: titleWidth,
							borderRadius: radius.badge,
						}}
					/>
					<SkeletonBlockLight
						sx={{
							height: sizing.skeletonTextHeightSm,
							width: sizing.skeletonItemDescWidths[0],
							borderRadius: radius.badge,
						}}
					/>
					<SkeletonBlockLight
						sx={{
							height: sizing.skeletonTextHeightSm,
							width: sizing.skeletonItemDescWidths[1],
							borderRadius: radius.badge,
						}}
					/>
				</SkeletonInfoGroup>
				{/* Price row */}
				<SkeletonBlock as={SkeletonPriceRow} />
			</SkeletonTextBody>

			{/* Image placeholder */}
			<SkeletonImagePlaceholder>
				<SkeletonAddButton />
			</SkeletonImagePlaceholder>
		</SkeletonCard>
	)
}

export default function MenuSkeleton() {
	return (
		<Box
			aria-hidden="true"
			data-testid="menu-skeleton"
			sx={{ pb: `${spacing.pageBottomPadding}px` }}
		>
			{sizing.skeletonCategoryHeaderWidths.map((headerWidth, catIndex) => (
				<SkeletonCategoryRow key={catIndex}>
					{/* Category heading skeleton */}
					<SkeletonBlock
						sx={{
							height: {
								xs: sizing.skeletonHeadingMobile,
								lg: sizing.skeletonHeadingDesktop,
							},
							width: headerWidth,
							mb: `${spacing.lg}px`,
						}}
					/>

					{/* Item cards grid — matches MenuPage two-column flex layout */}
					<SkeletonItemGrid>
						{Array.from({ length: sizing.skeletonItemTitleWidths.length }).map(
							(_, itemIndex) => (
								<ItemSlot key={itemIndex}>
									<SkeletonItem
										titleWidth={
											sizing.skeletonItemTitleWidths[
												itemIndex % sizing.skeletonItemTitleWidths.length
											]
										}
									/>
								</ItemSlot>
							),
						)}
					</SkeletonItemGrid>
				</SkeletonCategoryRow>
			))}
		</Box>
	)
}
